export function wrapIndex(index: number, count: number): number {
    if (count <= 0) return 0;
    return ((index % count) + count) % count;
}

export function clampIndex(index: number, count: number): number {
    if (count <= 0) return 0;
    return Math.min(Math.max(index, 0), count - 1);
}

// Arrows wrap around (a short gallery reads as a loop); Home and End jump to the ends.
export function indexForKey(key: string, current: number, count: number): number | null {
    if (count <= 1) return null;
    switch (key) {
        case 'ArrowLeft':
            return wrapIndex(current - 1, count);
        case 'ArrowRight':
            return wrapIndex(current + 1, count);
        case 'Home':
            return 0;
        case 'End':
            return count - 1;
        default:
            return null;
    }
}

export function positionLabel(index: number, count: number): string {
    return `${clampIndex(index, count) + 1} of ${count}`;
}

export function imageAltText(noun: string, index: number, count: number): string {
    return `${noun} ${positionLabel(index, count)}`;
}
